export default __webpack_public_path__ + "static/media/stone.4087b7a3.png";